import { Controller } from "@hotwired/stimulus"

// Disables a form's submit buttons once it submits, so a double-tap can't fire
// the action twice. Mount it on the form with
// data-action="submit->disable-on-submit#disable".
//
// Replaces an inline onsubmit="setTimeout(...)" that the enforcing CSP blocks.
// It listens to `submit`, not `click`, so a click another controller cancels
// (confirm#ask) never disables anything. The disable waits a tick because a
// disabled submitter drops its name/value from the request.
export default class extends Controller {
    disable() {
        setTimeout(() => {
            this.element.querySelectorAll("button[type=submit]").forEach((button) => {
                button.disabled = true
            })
        }, 0)
    }
}
